import React from 'react'
import { Container, Row, Col, Offcanvas, Nav,Navbar  } from 'react-bootstrap'


function NavBarVertical({children, title_menu = null,expand = "md"}) {

  return (
    <Container fluid style={{height:"100%"}}>
      <Row className='justify-content-center' style={{height:"100%"}}>
      {/* Si cambio el tamaño o las clases tengo que cambiarlo en el index.css */}
      <Col xs="2" sm="2" md="3" lg="3" xl="2" xxl="2" className="bg-body-tertiary p-0" style={{position:"relative"}} >
              
              {/* <div style={{position:"absolute",width:"100%", top:"6px"}}></div> */}
  
              <Navbar collapseOnSelect expand={expand} className="bg-body-tertiary p-0">
                <Container fluid className='p-0'>
                  
                <Navbar.Toggle aria-controls="navbarSearchAdvanced">{title_menu}</Navbar.Toggle>
                  
                <Navbar.Offcanvas id="navbarSearchAdvanced">
  
                  <Offcanvas.Header> Búsqueda avanzada </Offcanvas.Header>
                  <Offcanvas.Body>
  
                    <Nav className="me-auto" navbarScroll style={{width:"100%"}}>
                      <Container fluid >
                        <Row>
                          <Col className='p-0'>
                          
                          {
                                
                                React.Children.map(children, (child) => {
                                    
                                    if(child.type === NavBarVertical.Menu){
                                        return child;
                                    }
                                })
                            }
                            
                          </Col>
                        </Row>
                      </Container>
                    </Nav>
                  </Offcanvas.Body>
                </Navbar.Offcanvas>
  
                </Container>     
              </Navbar>
                    
            </Col>

        <Col xs="11" sm="11" md="9" lg="9" xl="10" xxl="10" className="">
            
          <Row>
              <Col>
                  {/* <p>Cerca de {sentences.total_records} resultados</p> */}
              </Col>
          </Row>

          <Row style={{minHeight:"87vh"}}>
              <Col>
              {
                      
                React.Children.map(children, (child) => {
                    
                    if(child.type === NavBarVertical.Content){
                        return child;
                    }
                })
              }
              </Col>
          </Row>

      
        </Col>
      </Row>
</Container>
  )
}


// Componente hijo para el menú
NavBarVertical.Menu = ({ children }) => {
    return <>{children}</>;
  };
  
  // Componente hijo para el contenido
  NavBarVertical.Content = ({ children }) => {
    return <>{children}</>;
  };

export default NavBarVertical